import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { BasicInformationService } from "../services/basic-information.service";
import { BasicInformation } from "../models/basicInformation";
import { QuestionAndAnswer } from "../models/questionsAndAnswers";
import { UserRoleEnum } from "../core/constant";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";

@Component({
  selector: "app-add-faq-page",
  templateUrl: "./add-faq-page.component.html",
  styleUrls: ["./add-faq-page.component.scss"],
})
export class AddFaqPageComponent implements OnInit {
  loading: boolean = false;
  isEditMode: boolean = false;
  faqId: number = 0;
  title: string = "";
  questions: { question: string; answer: string; hashtag: string }[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private basicInformationService: BasicInformationService,
    private ngbModal: NgbModal
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params["id"]) {
        this.faqId = +params["id"];
        this.isEditMode = true;
        this.loadFaq(this.faqId);
      } else {
        this.isEditMode = false;
        this.addQuestion();
      }
    });
  }

  loadFaq(id: number) {
    this.loading = true;
    this.basicInformationService.getBasicInformation(id).subscribe(
      (data: BasicInformation) => {
        if (data) {
          this.title = data.title || "";
          this.questions = [];
          if (data.questionsAndAnswers && data.questionsAndAnswers.length > 0) {
            data.questionsAndAnswers.forEach((item) => {
              let tagStr = item.hashtag || "";
              if (!tagStr && item.hashtags && item.hashtags.length > 0) {
                tagStr = item.hashtags.map((h) => h.name).join(", ");
              }
              this.questions.push({
                question: item.question || "",
                answer: item.answer || "",
                hashtag: tagStr,
              });
            });
          } else {
            this.addQuestion();
          }
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.addQuestion();
      }
    );
  }

  addQuestion() {
    this.questions.push({
      question: "",
      answer: "",
      hashtag: "",
    });
  }

  removeQuestion(index: number) {
    const q = this.questions[index];
    const hasContent =
      (q.question && q.question.trim()) ||
      (q.answer && q.answer.trim()) ||
      (q.hashtag && q.hashtag.trim());

    if (hasContent) {
      q.question = "";
      q.answer = "";
      q.hashtag = "";
    } else if (this.questions.length > 1) {
      this.questions.splice(index, 1);
    }
  }

  isFormValid(): boolean {
    if (!this.title || !this.title.trim()) {
      return false;
    }
    if (this.questions.length === 0) {
      return false;
    }
    return this.questions.every(
      (q) => q.question && q.question.trim() && q.answer && q.answer.trim()
    );
  }

  cancel() {
    this.router.navigate(["/faq"]);
  }

  submit() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    const postData = new BasicInformation();
    if (this.faqId > 0) {
      postData.id = this.faqId;
    }
    postData.title = this.title.trim();
    postData.createdUserId = UserRoleEnum.GlobalAdmin;
    postData.questionsAndAnswers = [];

    this.questions.forEach((q) => {
      const qa = new QuestionAndAnswer();
      qa.question = q.question.trim();
      qa.answer = q.answer.trim();
      qa.hashtag = q.hashtag ? q.hashtag.trim() : "";
      postData.questionsAndAnswers.push(qa);
    });

    if (this.faqId > 0) {
      this.basicInformationService.updateBasicInformation(postData).subscribe(
        () => {
          this.loading = false;
          const modalRef = this.ngbModal.open(SuccessDialogComponent);
          modalRef.componentInstance.message = "You have successfully updated FAQ.";
          modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
            this.ngbModal.dismissAll();
            this.router.navigate(["/faq"]);
          });
        },
        () => {
          this.loading = false;
        }
      );
    } else {
      this.basicInformationService.createBasicInformation(postData).subscribe(
        () => {
          this.loading = false;
          const modalRef = this.ngbModal.open(SuccessDialogComponent);
          modalRef.componentInstance.message = "You have successfully added FAQ.";
          modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
            this.ngbModal.dismissAll();
            this.router.navigate(["/faq"]);
          });
        },
        () => {
          this.loading = false;
        }
      );
    }
  }
}
